/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-unresolved */
import React from 'react';
import './Checkbox.css';
import Cross from '../Res/Icon/check-mark.png';

const Checkbox = ({ checked, onChange }) => {
  return (
    <>
      <div
        onClick={() => {
          if (typeof onChange === 'function') {
            onChange(!checked);
          }
        }}
        className="check-box"
      >
        {checked && (
          <img
            style={{ height: '100%', width: '100%', resize: 'contain' }}
            src={Cross}
            alt="CrossIcon"
          />
        )}
      </div>
    </>
  );
};

export default Checkbox;
